class YouMayLikeSlider {
  constructor() {
    this.slider = null;
    this.sliderSelector = '.cart-drawer__you-may-like-items';
    this.init();
    this.setupCartUpdateListener();
  }

  init() {
    this.destroySlider();
    setTimeout(() => {
      this.initializeSlider();
    }, 50);
  }

  setupCartUpdateListener() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => {
          this.init();
        }, 200);
      });
    }

    document.addEventListener('cart-drawer:open', () => {
      setTimeout(() => {
        this.init();
      }, 100);
    });
  }
  destroySlider() {
    if (this.slider && typeof this.slider.destroy === 'function') {
      try {
        this.slider.destroy();
      } catch (error) {
        console.warn('Error destroying slider:', error);
      }
      this.slider = null;
    }
  }
  initializeSlider() {
    const sliderElement = document.querySelector(this.sliderSelector);
    
    if (sliderElement && !sliderElement.classList.contains('slider-initialized')) {
      try {
        if (typeof Swiper !== 'undefined') {
          this.initSwiperSlider(sliderElement);
        }
        
        sliderElement.classList.add('slider-initialized');
      } catch (error) {
        console.error('Error initializing youMayLike slider:', error);
      }
    }
  }
  initSwiperSlider(element) {
    this.slider = new Swiper(element, {
      spaceBetween: 10,
      slidesPerView: 1,
      loop: false,
      scrollbar: {
        el: '.swiper-scrollbar-drawer',
        draggable: true,
      },
    });
  }

  reinitialize() {
    this.init();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.youMayLikeSlider = new YouMayLikeSlider();
});

if (typeof module !== 'undefined' && module.exports) {
  module.exports = YouMayLikeSlider;
}
